import EventEmitter from "events";
import {fetchJson} from "../../assets/request";
import {objectToFormData} from "../../assets/forms";

class ParkedService extends EventEmitter {

  constructor() {
    super();
    this.parked_machine_ids = [];
  }

  get ready() {
    return this._ready || this.init();
  }

  get count() {
    return this.parked_machine_ids.length;
  }

  init() {
    this._ready = this.loadParkedMachineIds();

    // An neues JS durchreichen
    this.on('update', () => window.dispatchEvent(new CustomEvent('legacy-parked-service:update')))

    return this._ready;
  }

  loadParkedMachineIds() {

    return fetchJson('/park/index/ajax-list/')
      .then((response) => {
        this.parked_machine_ids = response.machine_ids || [];
        this.emit("update");
        return this.parked_machine_ids;
      });
  }


  isMachineParked(machine_id) {
    return this.parked_machine_ids.some((id) => id == machine_id);
  }

  addMachineId(machine_id) {
    machine_id = parseInt(machine_id);
    if (machine_id > 0) {
      return fetch('/park/index/ajax-add/', {
        method: 'POST',
        body: objectToFormData({
          machine_id: machine_id
        })
      })
        .then(() => {
          this.parked_machine_ids.push(machine_id);
          this.emit("update");
        })
    } else {
      return Promise.reject();
    }
  }

  removeMachineId(machine_id) {
    machine_id = parseInt(machine_id);
    if (machine_id > 0) {
      return fetch('/park/index/ajax-remove/', {
        method: 'POST',
        body: objectToFormData({
          machine_id: machine_id
        })
      })
        .then(() => {
          let index = this.parked_machine_ids.indexOf(machine_id);
          if (index >= 0) {
            this.parked_machine_ids.splice(index, 1);
          }
          this.emit("update");
        })
    } else {
      return Promise.reject();
    }
  }

}

export default new ParkedService();
